import utils from '../apiCaller';

export const getSchedules = (from, to) =>
{
	return utils.fetch(`getMySchedules/${from}/${to}`);
};

export const saveSchedule = (body) =>
{
	return utils.store('createSchedule', body);
};

export const updateSchedule = (body) =>
{
	return utils.store('editSchedule', body);
};

export const deleteSchedule = (body) =>
{
	return utils.store('deleteSchedule', body);
};

export const verifySession = (sessionId) =>
{
	return utils.fetch(`verifyslot/${sessionId}`);
};